import { useMutation } from '@tanstack/react-query';

import { BusinessPlanFilesApi } from '../businessPlanFiles.api';

export const useBusinessPlanFileUploadComplete = () => {
  return useMutation({
    mutationFn: BusinessPlanFilesApi.completeFileUpload,
  });
};
